import { styled, CollapsableRow } from '@clickcease/cc-client-components-lib'

export const ExpandedDataContainer = styled('div', {
  padding: '0 $12 $8',
  fontWeight: '$l',
  fontSize: '$sm',
})

export const CollapsibleRowStyle = styled(CollapsableRow, {
  display: 'none',
})

export const Divider = styled('div', {
  width: '1px',
  margin: '0 $3',
  background: '$lightGray',
})

export const NoData = styled('div', {
  fontSize: '$md',
  marginLeft: '-$8',

  '> div': {
    width: 'auto',
  },
})

export const ExpandedRowHeader = styled('div', {
  display: 'flex',
  fontSize: '$md',
  fontWeight: '$sb',
  paddingRight: '$8',
  justifyContent: 'space-between',
  flexGrow: 1,
  alignItems: 'center',
})

export const ExpandedRowTitle = styled('div', {
  display: 'flex',
  flexGrow: 1,
})

export const ExpandedRowTitleText = styled('span', {
  color: '$black',
  fontWeight: '$sb',
})
export const ExpandedRowTitleDate = styled('span', {
  color: '$black',
  fontWeight: '$l',
  fontSize: '$sm',
  display: 'flex',
  alignItems: 'center',
  minWidth: '80px',
  whiteSpace: 'nowrap',
})

export const NewLabel = styled('span', {
  padding: '$1 $4',
  background: '$tableSelected',
  color: '$buttonPressed',
  borderRadius: '$normal',
  fontWeight: '$r',
  fontSize: '$sm',
})

export const ThreatTypeExplanation = styled('div', {})
